export default __webpack_public_path__ + "static/media/vaccine-program-mobile.9e4d1247.png";